<template>
  <div>
    <div
      :class="['item', index === value ? 'active' : '']"
      v-for="(item, index) in labelsArray"
      :key="index"
      @click="select(index)">
      <div v-if="index !== value">
        <p class="label">
          {{ item.title }}
        </p>
      </div>
      <div v-if="index === value">
        <p class="label">
          {{ item.title }}
        </p>
        <p class="prompt" v-if="index === initValue">
          {{ $t('currPlan') }}
        </p>
      </div>
      <img :src="Done_Circle" v-show="index === value" class="check-icon" />
    </div>
  </div>
</template>
<script>
import { Done_Circle } from '@/images'
export default {
  props: {
    labelsArray: {
      type: Array,
      required: true
    },
    initValue: {
      type: Number,
      default: 0
    },
    tag: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: this.initValue,
      Done_Circle
    }
  },
  watch: {
    initValue (val) {
      this.value = val
    }
  },
  methods: {
    select (index) {
      if (this.value === index) return
      this.value = index
      this.$emit('radioChange', {
        index: this.value,
        value: this.labelsArray[this.value],
        tag: this.tag
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .item {
    @include border-all(6px, $color-stage2, 0.5px);

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 345px;
    height: 60px;
    margin-bottom: 15px;
    padding: 0 15px;
    border-radius: 6px;
    background-color: $color-stage1;
    .label {
      color: $color-text;
      font-size: $base-font-size;
      font-family: $common-style-font-family-Medium;
      line-height: 22px;
    }
    .prompt {
      color: $color-stage5;
      font-size: 11px;
      font-family: $common-style-font-Family;
      line-height: 16px;
    }
    .check-icon {
      width: 20px;
      height: 20px;
    }
  }
  .active {
    @include border-all(6px, $color-primary, 1px);
  }
</style>
